import React, { createContext, useReducer } from "react";

const initialState = {
  baseUrl: "https://cms.sfpg.ch/api/",
  mediaBaseUrl: "",
  lang: localStorage.getItem("lang") || "en",
  home: {},
  header: [],
  footer: {},
  renovation: {},
  calculator: {},
  edelmetalle: {},
  edelmetalle_strategie: {},
  energieLosungen: {},
  finanz: {},
  immobielien: {},
  immobielienPrivate: {},
  ITLosungen: {},
  partners: {},
  trueHand: {},
  uber: {},
  versicherung: {},
  versicherung_uber: {},
  cashBack: {},
  versicherungPrivate:{},
  betrugspravention:{},
  activePage: {},
  calculatorTypes:{},
  calculatorResults:{},
  booking: {},
  services: {},
  calendar: {},
  lightMode: localStorage.getItem('lightMode') || false,
};

const defaultContextValue = {
  state: initialState,
  dispatch: () => initialState, // This is a placeholder function that does nothing
};

export const AppContext = createContext(defaultContextValue);

// Define the reducer function
const appReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "setHomeData":
      return {
        ...state,
        home: payload,
      };
    case "setHeaderData":
      return {
        ...state,
        header: payload,
      };
    case "setRenovationData":
      return {
        ...state,
        renovation: payload,
      };
    case "setCalculatorData":
      return {
        ...state,
        calculator: payload,
      };
    case "setCalculatorTypesData":
      return {
        ...state,
        calculatorTypes: payload,
      };
    case "setCalculatorResultsData":
      return {
        ...state,
        calculatorResults: payload,
      };
    case "setEdelmetalleData":
      return {
        ...state,
        edelmetalle: payload,
      };
    case "setEdelmetalleStrategieData":
      return {
        ...state,
        edelmetalle_strategie: payload,
      };
    case "setEnergieLosungenData":
      return {
        ...state,
        energieLosungen: payload,
      };
    case "setFinanzData":
      return {
        ...state,
        finanz: payload,
      };
    case "setBookingData":
      return {
        ...state,
        booking: payload,
      };
    case "setServicesData":
      return {
        ...state,
        services: payload,
      };
    case "setCalendaData":
      return {
        ...state,
        calendar: payload,
      }
    case "setImmobielienData":
      return {
        ...state,
        immobielien: payload,
      };
    case "setImmobielienPrivateData":
      return {
        ...state,
        immobielienPrivate: payload,
      };
    case "setITLosungenData":
      return {
        ...state,
        ITLosungen: payload,
      };
    case "setPartnersData":
      return {
        ...state,
        partners: payload,
      };
    case "setTrueHandData":
      return {
        ...state,
        trueHand: payload,
      };
    case "setUberData":
      return {
        ...state,
        uber: payload,
      };
    case "setVersicherungPrivateData":
      return {
        ...state,
        versicherungPrivate: payload,
      };
    case "setVersicherungData":
      return {
        ...state,
        versicherung: payload,
      };
    case "setVersicherungUberData":
      return {
        ...state,
        versicherung_uber: payload,
      };
    case "setCashBackData":
    return {
      ...state,
      cashBack: payload,
    };
    case "setBetrugspraventionData":
    return {
      ...state,
      betrugspravention: payload,
    };
    case "setFooterData":
      return {
        ...state,
        footer: payload,
      };
    case "setLang":
      localStorage.setItem("lang", payload);
      return {
        ...state,
        lang: payload,
      };
    case "setActivePageData":
      return {
        ...state,
        activePage: payload,
      }; 
    case "setLightMode":
      return {
        ...state,
        lightMode: payload,
      };
      default:
      return state;
  }
};

// Create a context provider component
export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  const contextValue = {
    state,
    dispatch,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};
